// extracted by mini-css-extract-plugin
export default {"container":"ArticleList_container__LfyQO","paging_btn":"ArticleList_paging_btn__Y5V0G"};